import { useState } from "react";
import type { FaqItem } from "@/types";

export default function FaqAccordion({
  items,
  defaultOpen = 0,
}: {
  items: FaqItem[];
  defaultOpen?: number | null;
}) {
  const [openId, setOpenId] = useState<number | null>(defaultOpen);

  return (
    <div className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item, index) => {
        const isOpen = openId === index;
        return (
          <div key={item.id}>
            <h3>
              <button
                type="button"
                aria-expanded={isOpen}
                aria-controls={`faq-panel-${item.id}`}
                onClick={() => setOpenId(isOpen ? null : index)}
                className="w-full flex items-start justify-between gap-4 py-4 md:py-5 text-left group"
              >
                <span className="flex items-start gap-3">
                  <span className="font-mono-num text-xs text-primary-500 mt-1">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <span className="font-heading text-base md:text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {item.question}
                  </span>
                </span>
                <span className="shrink-0 w-7 h-7 flex items-center justify-center rounded-full border border-background-300 text-foreground-600 mt-0.5">
                  <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                </span>
              </button>
            </h3>
            <div
              id={`faq-panel-${item.id}`}
              className={`grid transition-all duration-300 ${
                isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <p className="pb-5 pl-8 pr-10 text-sm md:text-[15px] leading-relaxed text-foreground-600">
                  {item.answer}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}